import React, { useState, useEffect, useContext } from "react";
import { BuildingContext } from "../../contexts/BuildingContext";
import { RoomContext } from "../../contexts/RoomContext";
import './EditRoomModal.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../ToastStyles.css';

const EditRoomModal = ({ isOpen, onClose, onUpdate, onDelete, currentRoom, buildingId }) => {
    
  const [roomStatus, setRoomStatus] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [roomName, setRoomName] = useState("");
  const [roomFloor, setRoomFloor] = useState("");
  const [isBasement, setIsBasement] = useState(false);
  const [roomContractArea, setRoomContractArea] = useState("");
  const [roomPrivateArea, setRoomPrivateArea] = useState("");
  const [roomWaterMeter, setRoomWaterMeter] = useState("");
  const [showEmptyAreaError, setShowEmptyAreaError] = useState(false);
  const [showAreaSizeError, setShowAreaSizeError] = useState(false);
  // const [showAreaError, setShowAreaError] = useState(false);

  const {updateRoom, fetchRooms, deleteRoom} = useContext(RoomContext);
  const {fetchBuildingDetails} = useContext(BuildingContext);

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    if (currentRoom) {
      setRoomStatus(currentRoom.roomStatus || "");
      setCustomerName(currentRoom.roomCustomerName || "");
      setRoomName(currentRoom.roomName || "");
      setRoomFloor(Math.abs(currentRoom.roomFloor) || "");
      setIsBasement(currentRoom.roomFloor < 0);
      setRoomContractArea(currentRoom.roomTotalArea || "");
      setRoomPrivateArea(currentRoom.roomPrivateArea || "");
      setRoomWaterMeter(currentRoom.roomWaterMeter || "");
    }
  }, [currentRoom]);

  useEffect(() => {
    const roomRow = document.querySelector(`.room-row[data-room-id="${currentRoom?.id}"] .room-specific-info-row`);

    if (isOpen && roomRow) {
      roomRow.classList.add('room-specific-info-row-darkened');
    } else if (roomRow) {
      roomRow.classList.remove('room-specific-info-row-darkened');
    }

    return () => {
      if (roomRow) {
        roomRow.classList.remove('room-specific-info-row-darkened');
      }
    };
  }, [isOpen, currentRoom]);

  useEffect(() => {
    if (parseFloat(roomPrivateArea) > parseFloat(roomContractArea)) {
      setShowAreaSizeError(true);
    } else {
      setShowAreaSizeError(false);
    }
  }, [roomContractArea, roomPrivateArea]);


  const handleUpdate = async () => {
    setShowEmptyAreaError(!roomPrivateArea);

    if (!roomStatus || !roomName || !roomFloor || !roomContractArea || !roomPrivateArea || showAreaSizeError || showEmptyAreaError) {
        return;
      }

    const updatedRoom = {
      ...currentRoom,
      roomStatus,
      roomCustomerName: customerName,
      roomName,
      roomFloor: isBasement ? -parseInt(roomFloor, 10) : parseInt(roomFloor, 10),
      roomTotalArea: roomContractArea,
      roomPrivateArea,
      roomWaterMeter,
    };
    // console.log("업데이트호실 정보", updatedRoom);
    // console.log("토큰:",token)
    // console.log("호실아이디: ",currentRoom.id)
    // console.log("건물아이디: ",buildingId)

    await updateRoom(currentRoom.id, updatedRoom); 

    toast.success("호실정보가 수정되었습니다.", {
        className: "custom-toast",
        bodyClassName: "custom-toast-body",
        closeButton: false,
        icon: <img src='/toastIcon.png' alt='Toast Icon' />
        });
    await fetchBuildingDetails(buildingId);
    onClose();
    window.location.reload();
  };


const handleDelete = async () => {
    await deleteRoom(currentRoom.id, buildingId);
    await fetchBuildingDetails(buildingId);
    onClose();
    window.location.reload();

  };
  
  if (!isOpen) return null;

  return (
    <div className="edit-room-modal">
      <div className="edit-room-modal-content">
        <h2>호실 정보 수정</h2>
        <div className="edit-room-modal-input-field">
          <label>호실 상태</label>
          <div className="room-state-buttons">
            {["EMPTY", "CONTRACT", "COMMON"].map(state => (
              <button
                key={state}
                className={`room-state-button ${roomStatus === state ? "active" : ""}`}
                onClick={() => {
                  setRoomStatus(state);
                  if (state !== "CONTRACT") setCustomerName("");
                }}
              >
                {state === "EMPTY" ? "공실" : state === "CONTRACT" ? "입실" : "공용공간"}
              </button>
            ))}
          </div>
          <label>임차사명</label>
          <input
            type="text"
            value={customerName}
            onChange={(e) => setCustomerName(e.target.value)}
            disabled={roomStatus !== "CONTRACT"}
            placeholder={
              roomStatus !== "CONTRACT"
                ? "입실의 경우에만 임차사명을 입력합니다"
                : ""
            }
          />
          <label>호실명</label>
          <input
            type="text"
            value={roomName}
            onChange={(e) => setRoomName(e.target.value)}
          />
          <label>층 수</label>
          <div className="room-floor-info-input-field">
            <input
              type="number"
              value={roomFloor}
              onChange={(e) => setRoomFloor(e.target.value)}
            />
            <select
              className="select-ground-basement"
              value={isBasement ? "지하" : "지상"}
              onChange={(e) => setIsBasement(e.target.value === "지하")}
            >
              <option value="지상">지상</option>
              <option value="지하">지하</option>
            </select>
          </div>
          <label>계약면적(m²)</label>
          <input
            type="number"
            value={roomContractArea}
            onChange={(e) => setRoomContractArea(e.target.value)}
          />
          <label>전용면적(m²)</label>
          <input
            type="number"
            value={roomPrivateArea}
            onChange={(e) => setRoomPrivateArea(e.target.value)}
            className={(showEmptyAreaError || showAreaSizeError) ? 'room-modal-error-input' : ''}
          />
          {showEmptyAreaError && (
            <div className="room-modal-error-message">
              전용면적을 입력해주세요.
            </div>
          )}
          {showAreaSizeError && (
            <div className="room-modal-error-message">
              전용면적이 계약면적보다 클 수 없습니다.
            </div>
          )}
          <label>수도계량기 번호 (선택)</label>
          <input
            type="text"
            value={roomWaterMeter}
            onChange={(e) => setRoomWaterMeter(e.target.value)}
          />
        </div>
        <div className="room-modal-buttons">
            <div className="edit-roon-modal-buttons-1">
                <button onClick={handleDelete} className="edit-room-delete-button">호실 삭제</button>
            </div>
            <div className="edit-room-modal-buttons-2">
                <button onClick={onClose}>취소</button>
                <button onClick={handleUpdate}>수정 완료</button>
            </div>
        </div>
      </div>
    </div>
  );
};

export default EditRoomModal;
